import * as React from "react"
import { SelectSeeker } from "@ui-seeker/core"
import { useSignal } from "@preact/signals-react"


const DAYS = Array.from({ length: 31 }, (_, i) => ({
    label: `${i + 1}`,
    value: i + 1
}))

export default function MonthDaySelect({ ...props }) {
    const dayValue = useSignal([])

    return <SelectSeeker
        options={DAYS}
        label="Select Month Days (Leave Empty Means Everyday)"
        value={dayValue.value}
        onChange={e => (dayValue.value = e.target.value)}
        isClearable
        {...props}
    />

}
